export const heroStats = [
  { label: "本轮入围作品", value: "128", unit: "件" },
  { label: "累计群众打分", value: "42.6", unit: "万" },
  { label: "参与投票网友", value: "9.3", unit: "万人" },
  { label: "距本轮截止", value: "3", unit: "天" },
];

export const hotTicker = [
  "《凌晨三点的办公室灯光》群众打分冲到 9.6",
  "新入围：年会抽奖箱里的隐秘纸条",
  "高能反转组出现并列第一",
  "神评论截图分类 24 小时新增 37 件投稿",
  "本轮投票将在 3 天后关闭通道",
  "幕后花絮组黑马作品挤进前十",
];

export const introFeatures = [
  {
    icon: "ri-fire-line",
    title: "群众打分，公开透明",
    desc: "每一件入围作品都由网友匿名打分，去掉最高分与最低分后取平均，评分实时展示在榜单上。",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "排名走势，看得见",
    desc: "不只是静态名次，作品在过去 24 小时的分数变化会以走势条呈现，谁在冲榜一目了然。",
  },
  {
    icon: "ri-shield-star-line",
    title: "内容审核，先审后展",
    desc: "所有投稿需通过人工初审，剔除不实与不友善内容后才进入入围名单，保证评选的干净与可信。",
  },
  {
    icon: "ri-group-line",
    title: "分类角逐，各有所长",
    desc: "名场面、反转、花絮、神评论等分类独立评比，让不同风格的爆料都能找到属于自己的舞台。",
  },
];

export const howItWorks = [
  {
    step: "01",
    title: "浏览入围名单",
    desc: "在入围名单页按分类筛选，挑出你想支持的作品，查看它的亮点摘要与当前得分。",
  },
  {
    step: "02",
    title: "为作品打分投票",
    desc: "给出你的分数即为投票，同一作品的投票在活动周期内只计一次，保证分数不被重复刷高。",
  },
  {
    step: "03",
    title: "围观排名更新",
    desc: "投票后回到排名结果页，查看你支持的作品有没有冲进前列，榜单随投票持续刷新。",
  },
];

export const siteStats = [
  { label: "已举办届数", value: "6" },
  { label: "累计投稿", value: "1.2 万+" },
  { label: "合作社区", value: "48" },
  { label: "活跃评分网友", value: "26 万+" },
];